import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import NavBar from './navBar';

import RestaurantList from '../../../components/restaurantList';

import Pagination from '../../../components/pagination';

import { getRestaurantList2021 } from '../../../../../services/api';

import AreaReports from '../../../components/areaReports';

import Slides from '../../../components/slides';

const initPagination = {
    pageNumber: 1,
    pageSize: 8,
};

class AreaFestival extends React.PureComponent {
    static propTypes = {
        curArea: PropTypes.string,
        content: PropTypes.object,
    };

    state = {
        searchValue: '',
        list: [],
        total: 0,
        pageNumber: initPagination.pageNumber,
        pageSize: initPagination.pageSize,
    };

    componentDidMount = () => {
        const { pageNumber, pageSize } = this.state;
        const { curArea } = this.props;

        this.asyncGetRestaurantList({ pageNumber, pageSize, type: 'gourmetFestival' });
    };

    handleSearchChange = searchValue => {
        this.setState({ searchValue });
    };

    handleSearch = () => {
        // console.log(this.state.searchValue);
        const { searchValue } = this.state;

        this.asyncGetRestaurantList({ ...initPagination, type: 'gourmetFestival', searchValue });
    };

    handleInitSearch = () => {
        this.setState({ searchValue: '' }, () => {
            this.asyncGetRestaurantList({ ...initPagination, type: 'gourmetFestival' });
        });
    };

    asyncGetRestaurantList = async params => {
        const res = await getRestaurantList2021(params);

        if (res && res.code === 0) {
            const { list, pageNumber, pageSize, total } = res.data;

            this.setState({ list, pageNumber, pageSize, total });
        }
    };

    handlePageChange = ({ pageNumber, pageSize }) => {
        const { searchValue } = this.state;
        const { curArea } = this.props;

        this.asyncGetRestaurantList({ pageNumber, pageSize, type: 'gourmetFestival', searchValue });
    };

    render() {
        /**
         * 组件分发数据
         */
        const { searchValue, list, pageNumber, pageSize, total } = this.state;
        const {
            curArea,
            content: { rule, judges, manOfTheYear, newsData, posters, showNews },
        } = this.props;

        return (
            <div className={styles.areaFestival}>
                <NavBar
                    searchValue={searchValue}
                    onChange={this.handleSearchChange}
                    onSeach={this.handleSearch}
                    onClear={this.handleInitSearch}
                    content={{ rule, judges, manOfTheYear }}
                    curArea={curArea}
                />
                <div style={{ margin: '25px 0 20px' }}>
                    <RestaurantList list={list} />
                </div>
                <Pagination current={pageNumber} total={total} pageSize={pageSize} onChange={this.handlePageChange} />
                {showNews ? (
                    <div className={styles.areaReports}>
                        <div className={styles.navBar}>
                            <div className={styles.header}>区域报道</div>
                        </div>
                        <AreaReports content={newsData} />
                    </div>
                ) : null}
                {showNews ? (
                    <div className={styles.scene}>
                        <div className={styles.navBar}>
                            <div className={styles.header}>盛典现场</div>
                        </div>
                        <Slides content={posters} />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(AreaFestival);
